import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { header } from 'app/_misc/headers';
import { ITranslations } from 'app/_models/ITranslations';
import { AppComponent } from 'app/app.component';
import { ISettings } from 'app/_models/ISettings';

@Injectable({ providedIn: 'root' })
export class UtilService {
  constructor(
    private httpClient: HttpClient, 
    private app: AppComponent
  ) { }

  getTranslations(formData: FormData) {
    return this.httpClient.post('/util/gettranslations', formData, {
      headers: new header().FormHeader, observe: 'response'
    }).pipe(map(response => {
      return response.body as ITranslations;
    }), catchError(this.handleError));
  }  

  getSiteName() {
    return this.httpClient.get('/util/getsitename', {
      headers: new header().JsonHeader, observe: 'response'
    }).pipe(map(response => {
      return response.body;
    }), catchError(this.handleError));
  }  

  getViewTypeUserAccess(formData: FormData) {
    return this.httpClient.post('/util/getviewtypeuseraccess', formData, {
      headers: new header().FormHeader, observe: 'response'
    }).pipe(map(response => {
      return response.body;
    }), catchError(this.handleError));
  }

  getViewName(formData: FormData) {
    return this.httpClient.post('/util/getviewname', formData, {
      headers: new header().FormHeader, observe: 'response'
    }).pipe(map(response => {
      return response.body;
    }), catchError(this.handleError));
  }

  getMsDetails() {
    return this.httpClient.get('/util/getmsdetails', {
      headers: new header().FormHeader, observe: 'response'
    }).pipe(map(response => {
      return response.body;
    }), catchError(this.handleError));
  }

  getSettings(): ISettings {
    let darkModeSetting: boolean = false;
    let followSystemDarkMode: boolean = false;
    let menuToggleSetting: boolean = true;
    let textSizeSetting: number = 15;
    let globalPadding: number = 10;
    let detailedErrorSetting: boolean = false; 
    let dateFormatSetting: string = 'dd/MM/yyyy';
    let compactGridSetting: boolean = false;
    let detailFiltersByRowSetting: boolean = false;
    let filterHistorySetting: boolean = true; 
    let storageConsent: boolean = false; 
    let filterDelaySetting: boolean = false;
    let freeColumnResizeSetting: boolean = false;
    let textAlignmentSetting: boolean = false;
    let stickyDetailHeadersSetting: boolean = true;
    let widgetsOpen: boolean = false;

    darkModeSetting = this.app.darkModeSetting;
    if (localStorage.getItem('qx_setting_matchSystemDarkMode')) {
      darkModeSetting = window.matchMedia('(prefers-color-scheme: dark)').matches;
      if (darkModeSetting) localStorage.setItem('qx_setting_darkMode', darkModeSetting.toString());
      else localStorage.removeItem('qx_setting_darkMode');      
      followSystemDarkMode = true;      
    }

    if (localStorage.getItem('qx_setting_menuToggle'))
      menuToggleSetting = this.app.tryParseBoolean(localStorage.getItem('qx_setting_menuToggle'));
   
    if (localStorage.getItem('qx_setting_textSize')) {
      textSizeSetting = Number(localStorage.getItem('qx_setting_textSize'));
      globalPadding = 10 - Math.floor(textSizeSetting / 5) - 1;
      if (globalPadding < 1 || textSizeSetting == 10) globalPadding = 2;
      if (globalPadding >= 15) globalPadding = 10;
    }

    if (localStorage.getItem('qx_setting_detailedErrors'))
      detailedErrorSetting = this.app.tryParseBoolean(localStorage.getItem('qx_setting_detailedErrors'));

    if (localStorage.getItem('qx_setting_dateFormat'))
      dateFormatSetting = localStorage.getItem('qx_setting_dateFormat');

    if (localStorage.getItem('qx_setting_compactGrid'))
      compactGridSetting = this.app.tryParseBoolean(localStorage.getItem('qx_setting_compactGrid'));

    if (localStorage.getItem('qx_setting_detailFiltersByRow'))
      detailFiltersByRowSetting = this.app.tryParseBoolean(localStorage.getItem('qx_setting_detailFiltersByRow'));

    if (localStorage.getItem('qx_setting_filterHistory'))
      filterHistorySetting = this.app.tryParseBoolean(localStorage.getItem('qx_setting_filterHistory'));

    if (localStorage.getItem('qx_storageConsent')) 
      storageConsent = true;

    if (localStorage.getItem('qx_setting_filterDelay'))
      filterDelaySetting = this.app.tryParseBoolean(localStorage.getItem('qx_setting_filterDelay'));

    if (localStorage.getItem('qx_setting_freeColumnResize'))
      freeColumnResizeSetting = this.app.tryParseBoolean(localStorage.getItem('qx_setting_freeColumnResize'));

    if (localStorage.getItem('qx_setting_textAlignment'))
      textAlignmentSetting = this.app.tryParseBoolean(localStorage.getItem('qx_setting_textAlignment'));

    if (localStorage.getItem('qx_setting_stickyDetailHeaders'))
      stickyDetailHeadersSetting = this.app.tryParseBoolean(localStorage.getItem('qx_setting_stickyDetailHeaders'));

    if (localStorage.getItem('qx_setting_widgetsOpen'))
      widgetsOpen = this.app.tryParseBoolean(localStorage.getItem('qx_setting_widgetsOpen'));

    return {     
      darkModeSetting,
      followSystemDarkMode,
      menuToggleSetting,
      textSizeSetting,
      globalPadding,
      detailedErrorSetting,
      dateFormatSetting,
      compactGridSetting,
      detailFiltersByRowSetting,
      filterHistorySetting,
      storageConsent,
      filterDelaySetting,
      freeColumnResizeSetting,
      textAlignmentSetting,
      stickyDetailHeadersSetting,
      widgetsOpen
    }
  }

  handleError(error: any) { return throwError(error); }
}